const currentPort =
  (typeof window !== 'undefined' && window?.location?.port) || '9002';

module.exports = {
  name: 'local',
  ampContent: 'http://local.hmhone.hmhco.com:9002/content',
  ampLoggedInURL: `http://local.hmhone.hmhco.com:${currentPort}/ui/logged-in/`,
  ampLogin: 'http://local.hmhone.hmhco.com:9002/ui/login/',
  ampLoginHelp: 'http://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  ampLoginPrivacyPolicy:
    'https://www.hmhco.com/prek-12-products-privacy-policy',
  ampLoginTermsAndConditions:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  apiEngHostname: 'https://api.int.br.internal',
  apiEngHostnamePublic: 'https://api.int.br.internal',
  assessments: 'http://local.hmhone.hmhco.com:9002/api/assessment',
  assignments: 'http://local.hmhone.hmhco.com:9002/api/assignment',
  authorizationApi: 'http://local.hmhone.hmhco.com:9000/api/authorization',
  auth0: 'https://hmhco-eng.auth0.com',
  auth0CreateConnectionsHost:
    'http://auth-self-service-setup.int.br.hmheng.io/api/v1/sso',
  auth0FetchConnectionsHost:
    'http://auth-self-service-setup.int.br.hmheng.io/api/v1/sso/datastore/connection',
  baseURL: 'http://local.hmhone.hmhco.com',
  classes: 'http://local.hmhone.hmhco.com:9002/ui/classes',
  classesClasses: 'http://local.hmhone.hmhco.com:9002/ui/classes/classes',
  clientRegistry: 'https://api.int.eng.hmhco.com/idm-client-registry',
  contentPicker: 'http://local.hmhone.hmhco.com:9000/picker/',
  contentPickerAMP: 'http://local.hmhone.hmhco.com:9002/ui/#/picker',
  contentProvider: 'http://local.hmhone.hmhco.com:9002/ui/#/contentProvider/',
  ctsDistrictLogin: 'http://local.hmhone.hmhco.com:9002/ui/login/?connection=',
  districtDownloadApi:
    'https://data-district-download-service.staging0.hmheng-ds.br.internal',
  ebrCore: 'https://api.int.br.internal/idm-ebr-core',
  ebrUi: 'http://int.hmhone.app.hmhco.com/ebr/',
  edContent: 'http://local.hmhone.hmhco.com:9000/content',
  edDistrictLogin: 'http://local.hmhone.hmhco.com:9000/ui/login/?connection=',
  edHostname: 'http://int.hmhone.app.hmhco.com/',
  edLoggedInURL: 'http://local.hmhone.hmhco.com:9000/logged-in',
  edLogin: 'http://local.hmhone.hmhco.com:9000/ui/login/',
  edRoot: 'http://local.hmhone.hmhco.com:9000/#/',
  EDSLoginUrl: 'https://app01.int.tsg.hmhco.com/edcore/eds-login',
  EDSResourceUrl:
    'https://app01.int.tsg.hmhco.com/edcore/hmheng-eds-api-gateway',
  forgotPassword:
    'http://local.hmhone.hmhco.com:9002/ui/login/forgot-password/',
  grading: 'http://local.hmhone.hmhco.com:9002/api/grading/',
  hmhHelpCenter: 'http://downloads.hmlt.hmco.com',
  hmoHostname: 'http://my-test.hrw.com/access/',
  hmoLoginPath: 'http://my-test.hrw.com/index.jsp',
  idm: 'http://int.app.sif.identity.api.hmhco.com/openid-connect',
  jasperReporting: 'https://int.hmhone.app.hmhco.com/jasperserver-pro',
  licensing: 'http://local.hmhone.hmhco.com:9002/ui/#/licenses',
  liftRoot: 'http://local.hmhone.hmhco.com:9002/ui/',
  loginPath: `:${currentPort}/ui/login/`,
  myClasses: 'http://local.hmhone.hmhco.com:9002/ui/!my-classes',
  myStuff: 'http://local.hmhone.hmhco.com:9002/ui/#/my-stuff/lessons',
  notificationsApi: 'https://api.int.eng.hmhco.com',
  oktaConnectionApi:
    'https://api.int.br.internal/okta-services-gateway/api/v1/sso',
  oktaFetchConnectionsHost:
    'https://api.int.br.internal/okta-services-gateway/api/v1/sso/idps',
  oktaNewOrg: 'https://int.hmhco.com/okta-services-gateway/api/v1/org', // this is deliberate to prevent a 401 logout on int
  onesearch: '/api/onesearch/v1',
  picker: 'http://local.hmhone.hmhco.com:9002/ui/#/picker/',
  plannerHost: 'https://planner-api.staging0.hmheng-csl.br.internal',
  plannerHostNonWaf: 'https://planner-api.staging0.hmheng-csl.br.internal',
  plsAuthors:
    'https://api.int.eng.hmhco.com/pls-services-author/api/v5/authors',
  plsLessonRelatedResource:
    'https://api.int.eng.hmhco.com/pls-services-lessonrelatedresource/api/v5/lessonrelatedresources',
  plsRelatedResources:
    'https://api.int.eng.hmhco.com/pls-services-relatedresource/api/v5/relatedresources',
  plsResource:
    'https://api.int.eng.hmhco.com/pls-services-resource/api/v5/resources',
  edsApiGateway: 'https://hapi.dev.hmhco.com/edcore/hmheng-eds-api-gateway/',
  prefixCDS: 'http://cds-metadatapipeline.int.br.hmheng.io',
  productLanding: 'http://local.hmhone.hmhco.com:9002/ui/#/product',
  restApi: 'https://api.int.eng.hmhco.com',
  restHapi: 'https://hapi.int.hmhco.com',
  restDMPS: 'https://api.int.br.internal/dmps',
  restDMPSNonWAF: 'https://api.int.br.internal/dmps',
  restELM: 'https://api.int.br.internal/elm/v1',
  restIdsApi: 'https://api.int.br.internal/ids', // for purging users in IDS we need a different API
  restIdsGridApi: 'https://api.int.br.internal/ids-grid-api',
  restIdsGridApiNonWAF: 'https://api.int.br.internal/ids-grid-api',
  restNotifications: 'https://api.int.eng.hmhco.com/notifications',
  restNotificationsNonWAF: 'https://api.int.eng.hmhco.com/notifications',
  restOAC: 'https://api.int.br.internal/oac/v3',
  restOACNonWAF: 'https://api.int.br.internal/oac/v3',
  restPostPrefix: 'http://int.hmhone.app.hmhco.com',
  restPrefix: 'http://int.hmhone.app.hmhco.com',
  restRecommendation: 'https://api.int.br.internal/recommendation-api',
  restStagingProcessor: 'https://api.int.br.internal/idm-staging-processor',
  restSusApi: 'https://api.int.br.internal/idm-user-api', // for purging users in SUS
  restUdsApi: 'https://api.int.eng.hmhco.com/uds',
  restUpdatesApi: 'https://api.int.eng.hmhco.com/update-catalog',
  rosterDashboard: 'http://local.hmhone.hmhco.com:9002/ui/#/roster',
  r180Api: 'http://local.hmhone.hmhco.com:9002/api/r180/',
  r180Media: 'https://int.hmhone.app.hmhco.com/r180/media',
  sisHostname: 'http://int.hmhone.app.hmhco.com/',
  sso: 'http://auth-self-service-setup.int.br.hmheng.io',
  storyBook: 'http://localhost:9009/',
  susAuth: '/api/authorization',
  tcHostname: 'http://www-int.thinkcentral.com/access/',
  tcLoginPath: 'http://www-int.thinkcentral.com/ePC/start.do',
  teacherDashboard: 'http://local.hmhone.hmhco.com:9002/ui/',
  linkedAssignments:
    'http://local.hmhone.hmhco.com:9002/ui/#/assign-full?resourceId=l_ff9bdd36-f627-4241-8dbc-9f9b4f158f56_c7b06f27-597b-42fc-8169-67247568e97f&programId=IM_NL20_G4&title=Unit+Opener%3A+Place+Value+and+Whole+Number+Operations&backTo=discover%252FIM_NL20_G4%252F1&showSched=true&recBy=NONE&isSgm=false',
  virtualClassroom: 'http://local.hmhone.hmhco.com:9002/ui/#/virtual-classroom',
  virtualClassroomApi:
    'https://api.int.eng.hmhco.com/vcservice/v2/virtual-classroom/meeting',
  wormhole: 'https://api.int.br.internal/wh-api/graphql',
  importingService: 'https://api.int.br.internal/idm-api-importing-service',
};
